export default __webpack_public_path__ + "assets/images/6f61ac1641ce84e6d05823f661221cd6.jpg";